/* import __COLOCATED_TEMPLATE__ from './mastercard-logo.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();